import { SocialFeedsSource } from "../../types/social-feeds";
export const urls = {
  platform: "https://www.trueloyal.com/platform",
  contact: "https://www.trueloyal.com/contact-us/",
  pricing: "https://www.trueloyal.com/pricing/",
  experiences: "https://www.trueloyal.com/platform/feature/social-contests-engagement/",
  contactUpgrade: "https://www.trueloyal.com/contact-us/?upgrade",
  apiDocumentation: "https://developers.trueloyal.com/v2/",
  embedLocationsHelp: "https://support.trueloyal.com/hc/en-us/articles/231452208-Embedding-your-TINT",
  collaboratorsHelp: "https://support.trueloyal.com/hc/en-us/articles/230870987-Collaborators",
  shopify: "https://apps.shopify.com/tint",
  productAccountsHelp: "https://support.trueloyal.com",
  productFeedsHelp: "https://support.trueloyal.com",
  productsCSVHelp: "https://support.trueloyal.com/hc/en-us/articles/360063684453-Custom-Product-Feed",
  productCSVSample: "https://support.trueloyal.com/hc/en-us/article_attachments/1500010230222/Sample.csv",
  marketingIntegrationsHelp: "https://support.trueloyal.com/hc/en-us/articles/1500008985061-Integrations-Overview",
  marketingIntegrationsHootsuiteApp: "https://apps.hootsuite.com/apps/tint",
  marketingIntegrationsZapierApp: "https://zapier.com/developer/public-invite/163089/7396e2287724fcec95dbbf005cd40bc9/",
  customDomainHelp: "https://support.trueloyal.com/hc/en-us/articles/360034278673-Custom-Domain-for-Experience-Builder-ExB-",
  tintMixLearn: "https://support.trueloyal.com/hc/en-us/articles/231888608",
  teamPreferencesLearn: "https://support.trueloyal.com/hc/en-us/articles/231453608-Keyword-and-Tag-Filtering ",
  zenDesk: {
    base: "https://support.trueloyal.com",
    saml: "https://support.trueloyal.com/hc/en-us/articles/360058983074",
    createTintAndAddContent: "https://support.trueloyal.com/hc/en-us/articles/231580527-Creating-a-TINT-and-Adding-Content",
    imageFilterRules: "https://support.trueloyal.com/hc/en-us/articles/115002081807",
    blockKeywordsRuleExample: "https://api.tintup.com/assets/naughty_words.csv",
    ugcRights: "https://support.trueloyal.com/hc/en-us/articles/230883267#h_01G023BZ0GJC2G4JWT7RQGJ359",
    widget: "https://static.zdassets.com/ekr/snippet.js?key=2618fffa-e1b7-4ac3-9941-f3aef9633517",
    twitter_integration: "https://support.trueloyal.com/hc/en-us/articles/16130285332371",
    webEmbedSettingsSavedLinks: "https://support.trueloyal.com/hc/en-us/articles/231453608",
    [SocialFeedsSource.TWITTER]: "https://support.trueloyal.com/hc/en-us/articles/10293427908627",
    [SocialFeedsSource.INSTAGRAM]: "https://support.trueloyal.com/hc/en-us/articles/360013162314",
    [SocialFeedsSource.INSTAGRAM_BUSINESS]: "https://support.trueloyal.com/hc/en-us/articles/360013162314",
    [SocialFeedsSource.FACEBOOK]: "https://support.trueloyal.com/hc/en-us/articles/13082694178835",
    [SocialFeedsSource.TUMBLR]: "https://support.trueloyal.com/hc/en-us/articles/13082709863059",
    [SocialFeedsSource.FLICKR]: "https://support.trueloyal.com/hc/en-us/articles/9768808346003",
    [SocialFeedsSource.SLACK]: "https://support.trueloyal.com/hc/en-us/articles/231752128",
    [SocialFeedsSource.HOOT_SUITE]: "https://support.trueloyal.com/hc/en-us/articles/231936008",
    [SocialFeedsSource.TIK_TOK]: "https://support.trueloyal.com/hc/en-us/articles/13082695779859",
    [SocialFeedsSource.WEBEX]: "https://support.trueloyal.com/hc/en-us/articles/231584027",
    [SocialFeedsSource.PINTEREST]: "https://support.trueloyal.com/hc/en-us/articles/7154676672147",
    [SocialFeedsSource.THREADS]: "https://support.trueloyal.com/hc/en-us/articles/31916517285395-Threads"
  },
  externalLinks: {
    chromecast: "https://play.google.com/store/apps/details?id=com.google.android.apps.chromecast.app&hl=en&gl=US",
    markdown: "https://daringfireball.net/projects/markdown/syntax?"
  },
  dropkiqCSS: "https://unpkg.com/dropkiq-ui@1.0.66/dist/dropkiq.css",
  dropkiqJS: "https://unpkg.com/dropkiq-ui@1.0.66/dist/dropkiq.min.js",
  tikTokEmbedScript: "https://www.tiktok.com/embed.js",
  youTubeEmbedScript: "https://www.youtube.com/iframe_api",
  customizeEmailTemplateArticle: "https://support.trueloyal.com/hc/en-us/articles/9006578907027",
  influencerDiscoveryContact: "https://www.trueloyal.com/contact/?influencer-discovery",
  discovery: {
    howCreateCommunity: "https://www.trueloyal.com/blog/how-to-create-a-community-powered-marketing-strategy/",
    howKnowWhenReady: "https://www.trueloyal.com/blog/how-do-i-know-when-im-ready-for-an-online-brand-community/",
    guideToZeroParty: "https://www.trueloyal.com/blog/how-to-use-zero-party-data/",
    howToBuildBrandAdvocacy: "https://www.trueloyal.com/blog/how-to-build-brand-advocacy/",
    howUseOnlineCommunity: "https://www.trueloyal.com/blog/how-to-use-an-online-community-to-get-more-product-reviews-right-now/",
    creatingACommunity: "https://www.trueloyal.com/blog/creating-a-community-how-to-tap-shared-identity-for-growth/"
  },
  rightsRequest: "//cdn.hypemarks.com/assets/terms/Sample_Content_Rights_ToS.pdf"
};
